var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"items":_vm.items,"placeholder":_vm.placeholder,"loading":"isLoading","no-data-text":"No data","append-icon":"search","solo":""},on:{"change":_vm.change}})
}
var staticRenderFns = []

export { render, staticRenderFns }